// extracted by mini-css-extract-plugin
export default {"buttons":"EditUserPage_buttons__omNur","left":"EditUserPage_left__fjjWf","right":"EditUserPage_right__43RTm"};